<template>
  <v-layout wrap>
    <v-flex xs12 class="title">
      <h2 :style="{ color: lastIntervalInHours > 70 ? 'red' : 'black' }">
        MediaFeed (dviewcontent) {{ lastIntervalInHours ? `[${lastIntervalInHours}min.]` : '' }} 
      </h2>
    </v-flex>
    <template v-for="(item, index) of cronData">
      <v-flex xs4 :key="`lmd${index}`" class="item">
        {{ item.LMD.split('.').shift().replace('T', '  🕒 ') }}
      </v-flex>
      <v-flex xs4 :key="`total${index}`" class="item">
        {{ item.XML }} / {{ item.Total }}
      </v-flex>
      <v-flex xs4 :key="`duration${index}`"  class="item">
        ⏱ {{ item.Duration }}
      </v-flex>
    </template>
    <v-flex xs12 class="action">
      <a @click="handleGetCronResult">refresh</a>
    </v-flex>
  </v-layout>
</template>
<script>
import axios from 'axios'
export default {
  data: () => ({
    lastIntervalInHours: null,
    cronData: []
  }),
  mounted () {
    this.handleGetCronResult()
  },
  methods: {
    handleGetCronResult () {
      axios.get(`https://rss-dviewcontent-api.dviewcontent.com/cron/`)
        .then(response => {
          if (!response) return 
          this.cronData = response.data.data
          let time = new Date(this.cronData.[0].LMD)
          this.lastIntervalInHours = this.getIntervalInHours(time)
        })
    },
    getIntervalInHours (v) {
      return parseInt((((new Date() - v) / 60000)))
    },
  },
}
</script>
<style scoped>
.title {
  background-color: #ccc;
  text-align: center;
  padding: 20px 10px;
}
.item {
  text-align: center;
  padding: 20px 10px;
  border-bottom: 1px solid #CCCCCC80;
}
.action {
  padding: 10px;
  text-align: right;
}
</style>

